import React, { useEffect, useState } from "react";
import "./TutorialModal.css";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import SelectField from "./MySelect";
import { useGetPickupQuery } from "../store/api/recipientApi";
import TextField from "./TextField";

export default function DeliveryModal({
  isOpen,
  onClose,
  title,
  description,
  link,
  btnTitle = "Понятно",
  onAccept,
  value = '',
  children,
}) {
  const navigate = useNavigate();
  const { data: pickup = { pickup_list: [] } } = useGetPickupQuery();
  const [form, setForm] = useState({
    address: value,
  });

  const handleOkClick = () => {
    onClose?.(link);
    if (onAccept) {
      onAccept(form);
      return;
    }
    if (link) {
      navigate(link);
    }
  };

  useEffect(() => {
    setForm({
      address: value
    })
  }, [value])
  if (!isOpen) return null;
  return (
    <div className="tutorial-modal-backdrop">
      <div className="tutorial-modal">
        <h2>{title}</h2>
        <p>
          {" "}
          {children} {description}
        </p>
        <TextField
          value={form.address}
          onChange={(e) => {
            setForm({
              ...form,
              address: e.target.value,
            });
          }}
          placeholder="Вводите адрес"
          options={pickup?.pickup_list}
          defaultValue=""
        />
        Доставка по г. Бишкек, с. Кок-жар, с. Орто-сай - 200 сом, в другие населенные пункты доставки нет.

        <div className="" style={{ display: "flex", gap: 12 }}>
          <Button style={{ padding: "16px 64px" }} onClick={handleOkClick}>
            {btnTitle}
          </Button>{" "}
          <Button
            style={{ padding: "16px 64px" }}
            className="danger"
            onClick={onClose}
          >
            Отмена
          </Button>
        </div>
      </div>
    </div>
  );
}
